import { IIconProps } from "../types"

export default function IconLL5(props: IIconProps) {
  const width = props.size || props.width || (81 / 5) * 3
  const height = props.size || props.height || (92 / 5) * 3
  return (
    <svg
      {...props}
      width={width}
      height={height}
      className={props.className}
      style={props.style}
      viewBox="0 0 81 92"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M45.3075 0.93425C41.8286 0.524382 37.8199 0.254468 33.4013 0.62435C28.9828 1.00423 24.1643 2.0139 20.1756 3.17353C16.1969 4.34316 13.0479 5.66273 10.8286 6.91233C8.60928 8.16193 7.3197 9.35155 5.98013 10.6012C4.64056 11.8607 3.261 13.1703 2.37128 14.8898C1.49157 16.5992 1.11169 18.7086 0.82178 21.4777C0.54187 24.2468 0.341934 27.6657 0.51188 32.814C0.681825 37.9524 1.21166 44.8102 2.18134 52.7576C3.16103 60.7151 4.59057 69.7622 5.98013 75.4304C7.35968 81.0985 8.69925 83.3778 10.6286 85.1173C12.568 86.8567 15.0972 88.0363 18.0962 89.076C21.1053 90.1057 24.5942 90.9854 27.9331 91.3353C31.272 91.6852 34.471 91.5052 37.62 90.7455C40.769 89.9757 43.878 88.6061 46.837 86.2569C49.7961 83.9076 52.6152 80.5687 57.0737 73.8509C61.5423 67.123 67.6504 57.0163 71.6991 49.6586C75.7578 42.301 77.7671 37.6925 78.9567 34.2836C80.1463 30.8846 80.5362 28.6854 80.4862 26.726C80.4363 24.7766 79.9564 23.0572 79.2966 21.4577C78.6268 19.8482 77.7671 18.3587 76.1176 16.6392C74.4682 14.9298 72.0389 13.0004 68.3401 10.6012C64.6413 8.21192 59.6729 5.35283 55.7142 3.64338C51.7555 1.92393 48.7964 1.35412 45.3075 0.93425Z"
        fill="#E6E6E6"
        stroke="black"
        strokeWidth="0.899712"
        strokeMiterlimit="2.61313"
      />
    </svg>
  )
}
